import { render, staticRenderFns } from "./expression.vue?vue&type=template&id=445fd9b2&"
import script from "./expression.vue?vue&type=script&lang=js&"
export * from "./expression.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports